export default "__VITE_ASSET__ad600e37__"